import { ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { SharedTranslateModule } from '../utils/sharedTranslateModule';
import { WindowRef } from '../utils/window';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthorizationService } from '../components/authorization/authorization.service';
import { DTFHomepageService } from '../components/dtfhomepage/dtfhomepage.service';
import { HeaderComponent } from '../furniture/header.component';
import { APP_CONSTANTS } from '../utils/app-constants';
import { RecaptchaLoaderService } from '../utils/recaptchaLoader.service';
import { TranslateUtil } from '../utils/translate-util';
import { ErrorLogService } from '../components/service/errorLogService';

@Component({
    selector: 'div.dtf-resetpassword',
    imports: [SharedTranslateModule,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatNativeDateModule, MatSortModule,
        MatDatepickerModule, MatIconModule],
    templateUrl: './resetpassword.component.html',
    providers: [WindowRef]
})
export class ResetpasswordComponent {

  constructor(router: Router, window: WindowRef,
    public auth: AuthorizationService, private fb: FormBuilder,public translateUtil: TranslateUtil,
    public translate: TranslateService, public recaptchaLoaderService: RecaptchaLoaderService,
    public dtfhomepageService: DTFHomepageService ,private headerComponent : HeaderComponent,
    private cdRef: ChangeDetectorRef, private errorLogService: ErrorLogService
    ) {
this.router = router;
this._window = window;
this.contextPath = (this._window.nativeWindow as any).mbfs.contextPath;
this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
}
private _window: WindowRef;
router: Router;
public registration: any;
isAuthenticated = false;
ciamLoginUrl = '';
contextPath = '';
currentCountry: string;
isCanadaPortal = false;
isReset = false;
userExist = false;
loginLoaded = true;
rendered: any;
captchaToggle = true;
isAuth = '';
userId = '';
admincheck:string;
password = '';
language = '';
hide = false;
openLoginModal = false;
serviceErrorOccurred = false;
serviceErrorDesc = '';
usUrl: string;
caUrl: string;
brandId: string;
targetRedirect = '';
registrationRedirect = '';
baseUrl = '';
logoutRedirect = '';
classicRedirect = '';
customerEmail ='';
emailCountValid=false;
emailCountnotValid=false;



ngOnInit() {
this.userId = sessionStorage.getItem('loginID');
this.admincheck = sessionStorage.getItem('admincheck');
this.translateUtil.setCountryAndLangFromUIProp();
this.translateUtil.getCurrentCountry().subscribe(val => {
this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
this.currentCountry = val;
this.cdRef.detectChanges();
});
this.auth.cast.subscribe(data => {
this.isAuthenticated = data;
this.cdRef.detectChanges();
});
this.contextPath = (this._window.nativeWindow as any).mbfs.contextPath;
this.language = (this._window.nativeWindow as any).mbfs.language;
this.auth.isAuthenticated(); // Checks if user is authenticated
let element:HTMLElement = document.getElementById('auto_trigger') as HTMLElement;
element.click();

if(this.admincheck ==='true'){
this.getAdminPasswordResetStepOne();
}
else{
this.getPasswordResetStepOne();
}
// this.onClickLogin(this.e);
}

onClickLogin(e: Event): void {
this.openLoginModal = true;
}

closeCIAMModal(e: Event) {
this.openLoginModal = false;
this.userExist = false;
this.isReset = false;
this.serviceErrorOccurred = false;
}

getPasswordResetStepOne(){
const passwordRequest = {
userId : this.userId,
language: this.language
};
this.auth.getPasswordResetStepOne(passwordRequest).subscribe(res => {
if(res.statusMessage ==='SUCCESS'){
this.customerEmail = res.email;
this.emailCountValid = true;
}
else{
this.emailCountnotValid = true;
this.errorLogService.logValidationError('Reset Password', 'userID', this.translate.instant('LoginModal.Attempts'), undefined, this.userId);
}
this.cdRef.detectChanges();
});
}

getAdminPasswordResetStepOne(){
const passwordRequest = {
userId : this.userId,
language: this.language
};
this.auth.prepareForAdminResetStepOne(passwordRequest).subscribe(res => {
if(res.statusMessage ==='SUCCESS'){
this.customerEmail = res.email;
this.emailCountValid = true;
}
else{
this.emailCountnotValid = true;
this.errorLogService.logValidationError('Reset Password', 'userID', this.translate.instant('LoginModal.Attempts'), undefined, this.userId);
}
this.cdRef.detectChanges();
});
}
reregister(){
const fakeEvent: Event = {} as Event; // Create a fake or empty event
this.headerComponent.onRegistrationClick(fakeEvent);
this.openLoginModal = false;
this.userExist = false;
this.isReset = false;
this.serviceErrorOccurred = false;
}


}
